import { FactoryRegistrationBuilder } from './FactoryRegistrationBuilder';
import { InstanceRegistrationBuilder } from './InstanceRegistrationBuilder';
import { TypeRegistrationBuilder } from './TypeRegistrationBuilder';
export class Builder {
    constructor(container) {
        this.container = container;
    }
    registerType(key) {
        return new TypeRegistrationBuilder(this.container, key);
    }
    registerInstance(instance) {
        return new InstanceRegistrationBuilder(this.container, instance);
    }
    register(factory) {
        return new FactoryRegistrationBuilder(this.container, factory);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnVpbGRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkJ1aWxkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLDBCQUEwQixFQUFFLE1BQU0sOEJBQThCLENBQUM7QUFDMUUsT0FBTyxFQUFFLDJCQUEyQixFQUFFLE1BQU0sK0JBQStCLENBQUM7QUFDNUUsT0FBTyxFQUFFLHVCQUF1QixFQUFFLE1BQU0sMkJBQTJCLENBQUM7QUFFcEUsTUFBTSxPQUFPLE9BQU87SUFDaEIsWUFBb0MsU0FBb0I7UUFBcEIsY0FBUyxHQUFULFNBQVMsQ0FBVztJQUFHLENBQUM7SUFFckQsWUFBWSxDQUFJLEdBQWdDO1FBQ25ELE9BQU8sSUFBSSx1QkFBdUIsQ0FBQyxJQUFJLENBQUMsU0FBUyxFQUFFLEdBQUcsQ0FBQyxDQUFDO0lBQzVELENBQUM7SUFFTSxnQkFBZ0IsQ0FBSSxRQUFXO1FBQ2xDLE9BQU8sSUFBSSwyQkFBMkIsQ0FBSSxJQUFJLENBQUMsU0FBUyxFQUFFLFFBQVEsQ0FBQyxDQUFDO0lBQ3hFLENBQUM7SUFFTSxRQUFRLENBQUksT0FBeUI7UUFDeEMsT0FBTyxJQUFJLDBCQUEwQixDQUFJLElBQUksQ0FBQyxTQUFTLEVBQUUsT0FBTyxDQUFDLENBQUM7SUFDdEUsQ0FBQztDQUNKIn0=